import { DynamicBaseForm } from './dynamic-base-form';

export class CheckBoxForm extends DynamicBaseForm<string> {
    controlType = 'CheckBoxForm';
}